<template>
  <div>
    <div v-for="(item, index) in menuItems" class="mb-4">
      <inertia-link
        class="flex items-center group py-3"
        :href="route(item.url)"
      >
        <icon
          :name="item.icon"
          class="w-10 h-10 mr-2"
          :class="
            isUrl('/$')
              ? 'fill-white'
              : 'fill-indigo-400 group-hover:fill-white'
          "
        />
        <div
          :class="
            isUrl('/$')
              ? 'text-black'
              : 'text-bold text-xl group-hover:text-black'
          "
        >
          {{ item.label }}
        </div>
      </inertia-link>
    </div>
  </div>
</template>

<script>
import Icon from "@/Shared/Icon";

export default {
  components: {
    Icon,
  },
  methods: {
    isUrl(...urls) {
      return urls.filter((url) => this.$page.url.match(url)).length;
    },
  },
  props: {
    menuItems: {
      type: Array,
      default: [
        { label: 'Фирми', url: 'accounts.index', icon: 'factory' },
        { label: 'Автомобили', url: 'carItems.index', icon: 'auto_home' }, // to change to homepage
        { label: 'Поддръжка и ремонт', url: 'homePage', icon: 'maintenance' },
        { label: 'Управление на гуми', url: 'homePage', icon: "wheel" },
        { label: 'Документи', url: 'homePage', icon: "truck" },
        { label: 'Наказателни постановления', url: 'homePage', icon: 'banknote' },
        { label: 'Пътен лист', url: 'homePage', icon: "road_list" },
        { label: 'Доклади', url: 'homePage', icon: 'reports-up' },
        { label: 'Известия', url: 'homePage', icon: 'fire' },
      ],
    },
    ttt: {
      type: String,
      default: "hahahaha",
    },
  },
};
</script>
